<template>
  <sidebar-wrapper>
    <widget-balance class="mt-4" />
    <nav-menu class="mt-3" />
  </sidebar-wrapper>
</template>

<script>
  import SidebarWrapper from './layout-default-sidebar-wrapper';
  import WidgetBalance from '@payment/components/widget-balance';
  import NavMenu from './layout-default-nav/nav.vue';

  export default {
    components: {
      SidebarWrapper,
      WidgetBalance,
      NavMenu
    }
  };
</script>
